/**
 * Normalizes a value that may be a single string or an array of strings
 * into a consistent string array. Used by multi-select handlers.
 */
export function toStringArray(value: string | string[]): string[] {
  return Array.isArray(value) ? value : value ? [value] : [];
}
